import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { finalize, Observable } from "rxjs";
import { LoaderService } from "src/app/shared/services/loader.service";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    
    //#region properties
    //#endregion

    //#region ctor
    constructor(private _loaderService: LoaderService) {}
    //#endregion

    //#region private actions
    private shouldSkipLoader(request: HttpRequest<any>): boolean {
        // Skip loader if request has X-Skip-Loader header
        return request.headers.has('X-Skip-Loader');
    }
    //#endregion

    //#region public actions
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip loader for requests with X-Skip-Loader header
        if (this.shouldSkipLoader(request)) {
            return next.handle(request);
        }

        // Show loader when request starts
        this._loaderService.showLoader();

        // Hide loader when request completes (success or error)
        return next.handle(request).pipe(
            finalize(() => {
                this._loaderService.hideLoader();
            })
        );
    }
    //#endregion
}

